import React from 'react';
import Sidebar from '../components/Sidebar';
import DashboardNavbar from '../components/DashboardNavbar';
import DashBoardCardsOne from '../components/DashBoardCardsOne';
import DbTable from '../components/DbTable';

const Dashboard = () => {
  return (
    <div className="d-flex entire-bg-color">
      <Sidebar />

      <div className="flex-grow-1">
        <DashboardNavbar />

        <DashBoardCardsOne />
        <DbTable />

        
      </div>
    </div>
  );
};

export default Dashboard;
